import { Component } from '@angular/core';

@Component({
  selector: 'app-slide-banners',
  templateUrl: './slide-banners.component.html',
  styleUrls: ['./slide-banners.component.scss']
})
export class SlideBannersComponent {
  images = [
    'https://remingtonco.vtexassets.com/assets/vtex.file-manager-graphql/images/89b230ba-f6a9-432a-9d27-3928d58da7ac___4e09e057e8eac80b093fe8983894502a.jpg',
    'https://remingtonco.vtexassets.com/assets/vtex.file-manager-graphql/images/577d69f1-51db-4cfb-b4d1-fb95e8424d30___6102ca18063eab0b5f0521c1f1e98f5e.jpg',
    'https://brand.assets.adidas.com/image/upload/f_auto,q_auto,fl_lossy/if_w_gt_1920,w_1920/lam_fw24_traning_banner_small_dropset2_clp_dual_d_1a355dafa0.jpg',
    'https://brand.assets.adidas.com/image/upload/f_auto,q_auto,fl_lossy/if_w_gt_960,w_960/lam_fw24_traning_banner_small_dropset2_clp_dual_t_f3016fa77d.jpg',
    'https://brand.assets.adidas.com/image/upload/f_auto,q_auto,fl_lossy/if_w_gt_1920,w_1920/lam_fw24_traning_banner_small_dropset2_clp_dual_d_1a355dafa0.jpg',

  ];
}
